import React from 'react'
import { useDigitalMarketerShopGate } from '../../hooks/useDigitalMarketerShopGate'
import DigitalMarketerShopModal from '../digitalMarketerShopModal'
import Anchor from '../anchor'

interface ShopNowLinkProps
  extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  href: string
  /** The plain retailer/product URL to prefill the share-link tool with, if different from `href`. */
  originalUrl?: string
  children: React.ReactNode
}

/**
 * Drop-in replacement for `<a href={trackingLink}>` on any single-anchor "shop now" call
 * site; new-tab handling comes from `<Anchor>`. Intercepts the click for Digital Marketers
 * (cashback disabled for that segment) and shows `<DigitalMarketerShopModal>` instead of
 * redirecting to the retailer. Every other user gets the normal click-through, including
 * any `onClick` passed in for analytics/tracking.
 */
const ShopNowLink = React.forwardRef<HTMLAnchorElement, ShopNowLinkProps>(
  ({ href, originalUrl, onClick, children, ...rest }, ref) => {
    const { interceptAnchorClick, modalProps } = useDigitalMarketerShopGate()

    return (
      <>
        <Anchor
          ref={ref}
          href={href}
          onClick={interceptAnchorClick(originalUrl || href, onClick)}
          {...rest}
        >
          {children}
        </Anchor>
        <DigitalMarketerShopModal {...modalProps} />
      </>
    )
  }
)

export default ShopNowLink
